<script setup lang="ts">
const props = defineProps<{
  class?: string;
}>();

defineOptions({ name: 'AppointmentStatusContent' });
</script>

<template>
  <div class="text-md text-gray-700" :class="props.class">
    <slot />
  </div>
</template>